<script>
  export default {
    computed: {
      querystring() {
        if (!this.params) { return ''; }
        return '?' + Object.keys(this.params).map((key) => key + '=' + this.params[key]).join('&');
      },
    },
    methods: {
      async getConfigurations() {
        try {
          this.$wait.start('loading configurations');
          const response = await this.$api.get(`configurations${this.querystring}`);
          return response.data;
        } catch (err) {
          this.$toast.error('There was an error getting configurations');
          return [];
        } finally {
          this.$wait.end('loading configurations');
        }
      },
      async addConfiguration(id, add) {
        try {
          this.$wait.start('loading configurations');
          const response = await this.$api.put(`configurations/${id}`, add);
          this.$toast.success(`'${add.name}' added`);
          return response;
        } catch (err) {
          this.$toast.error(`Could not add '${add.name}'`);
        } finally {
          this.$wait.end('loading configurations');
        }
      },
      async updateConfiguration(update) {
        try {
          this.$wait.start('loading configurations');
          const response = await this.$api.put(`configurations/${update.id}`, update);
          this.$toast.success(`'${update.name}' updated`);
          return response;
        } catch (err) {
          this.$toast.error(`Could not update '${update.name}'`);
          return [];
        } finally {
          this.$wait.end('loading configurations');
        }
      },
    },
  };
</script>
